/**
 * UI copy (`ui`) and printed-letter copy (`surat`), Bahasa Indonesia only, keyed by
 * screen, transcribed from CONTENT.md. Variable parts are `{placeholders}` filled by
 * `format`. Keys that start with an underscore are notes for the diocese, not copy.
 */
import surat from './surat.id.json' with { type: 'json' }
import ui from './ui.id.json' with { type: 'json' }

export {
  bacaTingkatAntara,
  isiTingkat,
  SEBUTAN_TINGKAT_BAWAAN,
  type SebutanTingkat,
  sebutanTingkat,
  TINGKAT_ANTARA,
  TINGKAT_ANTARA_BAWAAN,
  type TingkatAntara,
  tanpaSebutanTingkat,
  tingkatBangun,
} from './tingkat'
export {
  isiUnit,
  SEBUTAN_BAWAAN,
  SEBUTAN_UNIT_BAWAAN,
  type SebutanUnit,
  sebutanUnit,
  tanpaSebutanUnit,
} from './unit'
export { surat as suratStrings, ui as uiStrings }
export type UiStrings = typeof ui
export type SuratStrings = typeof surat

/** Fill `{name}` placeholders; unknown names are left in place so a gap is visible. */
export function format(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{([A-Za-z0-9_]+)\}/g, (whole, name: string) => {
    const value = values[name]
    return value === undefined ? whole : String(value)
  })
}
